import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

// THUNK - Lista agenti
export const getAgentsList = createAsyncThunk(
    'agents/getAgentsList',
    async ({ token }, { rejectWithValue }) => {
    try {
        const url = `${import.meta.env.VITE_API_BASE_URL}/agents`;
        const headers = {
            'Content-Type': 'application/json',
            'auth-token': token
        };
        const response = await fetch(url, { method: 'GET', headers });

        if (!response.ok) {
            const error = await response.json();
            return rejectWithValue({
                message: error.message || 'Errore nel caricamento degli agenti.'
            });
        }
        return await response.json();
    } catch (error) {
        return rejectWithValue({
            message: (error instanceof Error) ? error.message : 'Errore di rete. Riprova più tardi.'
        });
    }
});

// THUNK - Lista permessi disponibili
export const getAgentPermissions = createAsyncThunk(
    'agents/getAgentPermissions',
    async ({ token }, { rejectWithValue }) => {
    try {
        const url = `${import.meta.env.VITE_API_BASE_URL}/agents/permissions`;
        const headers = {
            'Content-Type': 'application/json',
            'auth-token': token
        };
        const response = await fetch(url, { method: 'GET', headers });

        if (!response.ok) {
            const error = await response.json();
            return rejectWithValue({
                message: error.message || 'Errore nel caricamento dei permessi.'
            });
        }
        const result = await response.json();
        return result.permissions;
    } catch (error) {
        return rejectWithValue({
            message: (error instanceof Error) ? error.message : 'Errore di rete. Riprova più tardi.'
        });
    }
});

const initialState = {
    data: [],
    permissions: [],
    isLoading: false,
    error: null
};

const agentsSlice = createSlice({
    name: 'agents',
    initialState,
    reducers: {
        clearAgentsData: (state) => {
            state.data = [];
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAgentsList.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getAgentsList.fulfilled, (state, action) => {
                state.data = action.payload;
                state.error = null;
                state.isLoading = false;
            })
            .addCase(getAgentsList.rejected, (state, action) => {
                state.error = action.payload?.message || "Errore sconosciuto nel caricamento degli agenti.";
                state.isLoading = false;
            })
            .addCase(getAgentPermissions.fulfilled, (state, action) => {
                state.permissions = action.payload;
            })
    }
});

// Selectors
export const selectAgentsData = (state) => state.agents.data;
export const selectAgentsLoading = (state) => state.agents.isLoading;
export const selectAgentsError = (state) => state.agents.error;
export const selectAgentPermissions = (state) => state.agents.permissions;

export const { clearAgentsData } = agentsSlice.actions;
export default agentsSlice.reducer;
